module.exports = __webpack_public_path__ + "img/buy-ticket.9ab9030a.svg";